// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1AgFZ","inner":"Form_inner__2IXgN","range":"Form_range__2GjsO","name":"Form_name__1Puel","actions":"Form_actions__TELRf"};